var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"works"},[_vm._m(0),_c('div',{staticClass:"worksContent"},[_c('ul',{staticClass:"tabs"},[_c('li',{class:{'active': _vm.isActive === '1'},on:{"click":function($event){return _vm.change('1')}}},[_vm._v("ALL")]),_c('li',{class:{'active': _vm.isActive === '2'},on:{"click":function($event){return _vm.change('2')}}},[_vm._v("PROGRAMMING")]),_c('li',{class:{'active': _vm.isActive === '3'},on:{"click":function($event){return _vm.change('3')}}},[_vm._v("MUSIC")]),_c('li',{class:{'active': _vm.isActive === '4'},on:{"click":function($event){return _vm.change('4')}}},[_vm._v("ELECTONE")]),_c('li',{class:{'active': _vm.isActive === '5'},on:{"click":function($event){return _vm.change('5')}}},[_vm._v("OTHERS")])]),_c('ul',{staticClass:"contents"},[(_vm.isActive === '1')?_c('li',_vm._l((_vm.sortedList),function(ref){
var id = ref.id;
var name = ref.name;
var date = ref.date;
var img = ref.img;
var content = ref.content;
var moreInfo = ref.moreInfo;
var tag = ref.tag;
var tag2 = ref.tag2;
return (tag === 'work')?_c('articleCard',{key:id,attrs:{"id":id,"article_title":name,"article_date":date,"article_img":img,"article_content":content,"article_moreInfo":moreInfo,"article_tag":tag,"article_tag2":tag2}}):_vm._e()}),1):_vm._e(),(_vm.isActive === '2')?_c('li',_vm._l((_vm.sortedList),function(ref){
var id = ref.id;
var name = ref.name;
var date = ref.date;
var img = ref.img;
var content = ref.content;
var moreInfo = ref.moreInfo;
var tag = ref.tag;
var tag2 = ref.tag2;
return (tag === 'work' && tag2 === 'programming')?_c('articleCard',{key:id,attrs:{"id":id,"article_title":name,"article_date":date,"article_img":img,"article_content":content,"article_moreInfo":moreInfo,"article_tag":tag,"article_tag2":tag2}}):_vm._e()}),1):_vm._e(),(_vm.isActive === '3')?_c('li',_vm._l((_vm.sortedList),function(ref){
var id = ref.id;
var name = ref.name;
var date = ref.date;
var img = ref.img;
var content = ref.content;
var moreInfo = ref.moreInfo;
var tag = ref.tag;
var tag2 = ref.tag2;
return (tag === 'work' && tag2 === 'music')?_c('articleCard',{key:id,attrs:{"id":id,"article_title":name,"article_date":date,"article_img":img,"article_content":content,"article_moreInfo":moreInfo,"article_tag":tag,"article_tag2":tag2}}):_vm._e()}),1):_vm._e(),(_vm.isActive === '4')?_c('li',_vm._l((_vm.sortedList),function(ref){
var id = ref.id;
var name = ref.name;
var date = ref.date;
var img = ref.img;
var content = ref.content;
var moreInfo = ref.moreInfo;
var tag = ref.tag;
var tag2 = ref.tag2;
return (tag === 'work' && tag2 === 'electone')?_c('articleCard',{key:id,attrs:{"id":id,"article_title":name,"article_date":date,"article_img":img,"article_content":content,"article_moreInfo":moreInfo,"article_tag":tag,"article_tag2":tag2}}):_vm._e()}),1):_vm._e(),(_vm.isActive === '5')?_c('li',_vm._l((_vm.sortedList),function(ref){
var id = ref.id;
var name = ref.name;
var date = ref.date;
var img = ref.img;
var content = ref.content;
var moreInfo = ref.moreInfo;
var tag = ref.tag;
var tag2 = ref.tag2;
return (tag === 'work' && tag2 === 'others')?_c('articleCard',{key:id,attrs:{"id":id,"article_title":name,"article_date":date,"article_img":img,"article_content":content,"article_moreInfo":moreInfo,"article_tag":tag,"article_tag2":tag2}}):_vm._e()}),1):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("WORKS")])])}]

export { render, staticRenderFns }